(function () {
  function init() {
    document.querySelectorAll('.product__media-wrapper').forEach(function (wrapper) {
      if (wrapper.dataset.gkDotsBound) return;
      wrapper.dataset.gkDotsBound = '1';

      const list = wrapper.querySelector('.product__media-list');
      if (!list) return;
      const items = Array.from(list.querySelectorAll('.product__media-item')).filter(function (el) {
        return el.offsetParent !== null || el.classList.contains('slider__slide');
      });
      if (items.length <= 1) return;

      const counterContainer = wrapper.querySelector('.slider-buttons');
      if (!counterContainer) return;

      const dotsList = document.createElement('ul');
      dotsList.className = 'gk-pmd';
      dotsList.setAttribute('role', 'tablist');

      items.forEach(function (item, idx) {
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gk-pmd__btn' + (idx === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Ir para a imagem ' + (idx + 1));
        btn.dataset.index = idx;
        btn.addEventListener('click', function () {
          scrollToItem(list, items[idx]);
        });
        li.appendChild(btn);
        dotsList.appendChild(li);
      });

      const counter = counterContainer.querySelector('.slider-counter');
      if (counter) counter.replaceWith(dotsList);
      else counterContainer.insertBefore(dotsList, counterContainer.firstChild);

      const dots = Array.from(dotsList.querySelectorAll('.gk-pmd__btn'));

      function syncActive() {
        const center = list.scrollLeft + list.clientWidth / 2;
        let closest = 0;
        let closestDist = Infinity;
        items.forEach(function (item, i) {
          const itemCenter = item.offsetLeft + item.clientWidth / 2;
          const dist = Math.abs(itemCenter - center);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === closest);
        });
      }

      list.addEventListener('scroll', syncActive, { passive: true });
      window.addEventListener('resize', syncActive);

      // Also sync when Dawn's prev/next buttons are pressed (slider-component)
      wrapper.querySelectorAll('.slider-button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setTimeout(syncActive, 350);
        });
      });

      requestAnimationFrame(syncActive);
    });
  }

  function scrollToItem(list, item) {
    const offset = item.offsetLeft - list.offsetLeft;
    list.scrollTo({ left: offset, behavior: 'smooth' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
